import { observer } from 'mobx-react-lite'
import type { TaxInfoGatheringPageViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringPageViewModel'
import {
  NotesSection,
  NotesCardListItem,
  EmptyNotesCardListItem,
} from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections'
import type { NotesRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/notes/NotesRequestedSupportingItemViewModel'

interface NotesSectionContainerProps {
  vm: TaxInfoGatheringPageViewModel
}

export const NotesSectionContainer = observer(function NotesSectionContainer({
  vm,
}: NotesSectionContainerProps) {
  const notesItemVms =
    vm.infoGatheringVm.requestedSupportingItemVms.items.filter(
      (itemVm): itemVm is NotesRequestedSupportingItemViewModel =>
        itemVm?.type === 'Notes',
    )

  if (notesItemVms.length === 0) {
    return null
  }

  return (
    <NotesSection testId="notes-section">
      {notesItemVms.map((itemVm) =>
        itemVm.isCompleted ? (
          <NotesCardListItem
            key={itemVm.item.id}
            text={itemVm.item.input.text}
            onAction={itemVm.showDialog}
          />
        ) : (
          <EmptyNotesCardListItem
            key={itemVm.item.id}
            onAction={itemVm.showDialog}
          />
        ),
      )}
    </NotesSection>
  )
})
